import state from './reportState'
import mutations from './reportMutations'
import getters from './reportGetters'
import actions from './reportActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
